import { gql } from "@apollo/client";

export const CREATE_OPTION_PRICE = gql`
  mutation CreateOptionPrice($input: OptionPriceInput) {
    createOptionPrice(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const UPDATE_OPTION_PRICE = gql`
  mutation UpdateOptionPrice($id: ID!, $input: OptionPriceInput) {
    updateOptionPrice(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_OPTION_PRICE = gql`
  mutation DeleteOptionPrice($id: ID!) {
    deleteOptionPrice(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_OPTION_PRICE_PAGINATION = gql`
  query GetOptionPricePagination(
    $page: Int
    $limit: Int
    $keyword: String
    $pagination: Boolean
    $classId: String
  ) {
    getOptionPricePagination(
      page: $page
      limit: $limit
      keyword: $keyword
      pagination: $pagination
      classId: $classId
    ) {
      data {
        _id
        default
        payStatus
        accessedLessonIds {
          _id
          numbering
          title
          image
        }
        packagepriceIds {
          _id
          classId {
            _id
            className
            courseId {
              _id
              enName
              khName
              remark
              totalHour
            }
          }
          groupFeeId {
            _id
            type
            title
            price
            remark
          }
          duration
          discountType
          discountAmount
          title
          unlimited
        }
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;
